import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';

import * as Vali from 'helper/validator-helper';
import * as MEnum from './maintenance-enums';
import * as ProjectActionType from 'Projects/constants';

import { Input, TextArea } from 'components/ValidationInput';
import { Dropdown } from 'components/Dropdown/Dropdown';

import './maintenance.scss';
import MaintenanceServices from './services';

export class SpecificTaskAdd extends Component {
    static propTypes = {
      dispatch: PropTypes.func,

      inventoryItemId: PropTypes.string,
      inventoryItemProfile: PropTypes.object,

      goToList: PropTypes.func,
      goToEdit: PropTypes.func
    }

    constructor(props) {
      super(props);

      this.maintenanceService = new MaintenanceServices(this.props.dispatch);
      this.state = {
        searchText: '',
        inventoryItemName: null,

        selectedType: MEnum.TASK_TYPE_LIST[0],
        selectedRepeatPeriodType: MEnum.REPEAT_PERIOD_LIST[0],
        selectedRepeatStartType: MEnum.REPEAT_START_LIST[0],
        selectedRepeatEndType: MEnum.REPEAT_END_LIST[0]
      };
    }

    componentDidMount() {
      if (this.props.inventoryItemId) {
        this.getInventoryProfile(this.props.inventoryItemId);
      }

      window.scrollTo(0, 0);
    }

    componentWillReceiveProps(nextProps) {
      if (this.props.inventoryItemProfile !== nextProps.inventoryItemProfile) {
        this.setState({
          inventoryItemName: nextProps.inventoryItemProfile.name
        });
      }
    }

    // manual events

    onTextInputChange = (inputName, obj) => {
      let hasError = false;

      if (!this.textInputs) {
        this.textInputs = {};
      }

      this.textInputs[inputName] = obj;

      for (let key in this.textInputs) {
        if (this.textInputs[key].error) {
          hasError = true;
          break;
        }
      }

      this.setState({ hasError: hasError });
    }

    onClickCreateButton = (e) => {
      e.preventDefault();

      this.maintenanceService.createSpecificTask(
        this.props.inventoryItemId,
        this.textInputs.name.value,
        this.textInputs.description.value,
        this.state.selectedType.value,
        this.state.selectedRepeatPeriodType.value,
        this.state.selectedRepeatStartType.value,
        this.state.selectedRepeatEndType.value,
        this.props.goToEdit()
      );
    }

    // end manual events

    // helpers

    getInventoryProfile = (id, callback) => {
      this.props.dispatch({
        type: ProjectActionType.GET_INVENTORY_ITEM_PROFILE_ASYNC,
        params: { id: id },
        callback
      });
    }

    // end helpers

    // renders
    renderRepeatSection(condition) {
      if (!condition) {return null;}

      return (
        <React.Fragment>
          <div className='row'>
            <div className='col-md-12'>
              <Dropdown
                name='schedule_period'
                style={{width: '100%'}}
                className='filestring-dropdown'
                value={this.state.selectedRepeatPeriodType}
                options={MEnum.REPEAT_PERIOD_LIST}
                optionLabel='text'
                onChange={(e) => {this.setState({selectedRepeatPeriodType: e.value});}}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6'>
              <label>Starts<span className='text-danger'> *</span></label>
              <Dropdown
                name='schedule_start'
                style={{width: '100%'}}
                className='filestring-dropdown'
                value={this.state.selectedRepeatStartType}
                options={MEnum.REPEAT_START_SPECIFIC_LIST}
                optionLabel='text'
                onChange={(e) => {this.setState({selectedRepeatStartType: e.value});}}
              />
            </div>
            <div className='col-md-6'>
              <label>Ends<span className='text-danger'> *</span></label>
              <Dropdown
                name='schedule_end'
                style={{width: '100%'}}
                className='filestring-dropdown'
                value={this.state.selectedRepeatEndType}
                options={MEnum.REPEAT_END_LIST}
                optionLabel='text'
                onChange={(e) => {this.setState({selectedRepeatEndType: e.value});}}
              />
            </div>
          </div>
        </React.Fragment>);
    }

    render() {
      const breadCrumbs = [
        {title: 'Inventory items', url: '/', onCustomAction: this.props.goToList},
        {title: `${this.props.inventoryItemProfile.name}`, url: '/', onCustomAction: this.props.goToEdit},
        {title: 'Add New Maintenance Task', url: ''}
      ];

      return (
        <React.Fragment>
          <div className='row'>
            <div className='col-md-12'>
              <h4 style={{marginTop: 0}}>{breadCrumbs[2].title}</h4>
              <Breadcrumb breadcrumbs={breadCrumbs} />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-10'>
              <div className='form-group'>
                <label htmlFor='name'>Name<span className='text-danger'>*</span></label>
                <Input
                  type='text'
                  name='name'
                  onChange={v => this.onTextInputChange('name', v)}
                  validators={[Vali.required]}
                />
              </div>
              <div className='form-group'>
                <label htmlFor='description'>Description</label>
                <TextArea
                  name='description'
                  rows={5}
                  onChange={v => this.onTextInputChange('description', v)}
                />
              </div>
              <div className='form-group'>
                <div className='row'>
                  <div className='col-md-3'>
                    <Dropdown
                      name='schedule_month'
                      style={{width: '100%'}}
                      className='filestring-dropdown'
                      value={this.state.selectedType}
                      options={MEnum.TASK_TYPE_LIST}
                      optionLabel='text'
                      onChange={(e) => {this.setState({selectedType: e.value});}}
                    />
                  </div>
                  <div className='col-md-9'>
                    {
                      this.renderRepeatSection(this.state.selectedType.value === 0)
                    }
                  </div>
                </div>
              </div>
              {
                <div style={{marginTop: 20}}>
                  <div className='col-xs-12 row'>
                    <span className='btn btn-siteone-default' onClick={this.props.goToEdit}>Cancel</span>
                    <button type='button'
                      className='btn btn-primary btn-siteone'
                      disabled={this.state.hasError ? 'disabled' : null}
                      onClick={(e) => this.onClickCreateButton(e)}>Create</button>
                  </div>
                </div>
              }
            </div>
          </div>
        </React.Fragment>
      );
    }
}
const mapStateToProps = (state) => {
  return {
    inventoryItemProfile: state.ProjectStore.inventoryItemProfile
  };
};

export default connect(mapStateToProps)(SpecificTaskAdd);



// WEBPACK FOOTER //
// ./src/Projects/Components/Maintenance/task-specific-add.js